import React, { useRef } from 'react';
import OndeffModal from './OndeffModal';
import { formatData } from '../helpers/helpers';

const CallToActionDescription = (props) => {
  const btnLabel = props.btnLabel || 'Get a quote'
  const childRef = useRef();

  const handleClick = (e) => {
    e.stopPropagation();
    let foundAddress = false;
    if (props.onlineBooking) {
      if(typeof window !== 'undefined'){ 
        const localData = JSON.parse(localStorage.getItem('onlineBookingData'));
        if(localData){
          if(localData.finalDataForBooking) {
            const data = localData.finalDataForBooking
            const formattedData = formatData(data);
            if(formattedData.odf_postal_code) {
              foundAddress = true;
            }
          } else {
            const initialDataValues = localData.initialValues?.find(data => data.key === 'fullFormData')?.value;
            if(initialDataValues.odf_postal_code) {
              foundAddress = true;
            }
          }
        }
      }
    } else if (childRef.current) {
      return childRef.current.triggerChangeShowModal();
    }
    if (foundAddress && typeof window !== 'undefined') {
      window.location.href = props.proUrl ? props.proUrl : "/book";
    } else if (childRef.current) {
      childRef.current.triggerChangeShowModal();
    }
  };
  
  return (
    <>
      <div className="flex-footer" onClick={handleClick}>
        {props.detail &&
        <div class='call-to-action-info'>
          <span>+</span>
          <p>{props.detail}</p>
        </div>
        }
        <button style={{ cursor: 'pointer' }} className={props.class} >{btnLabel}</button>
      </div>
      <OndeffModal
        {...props}
        ref={childRef}
      />
    </>
  )
}

export default CallToActionDescription;
